/* eslint-disable no-param-reassign */
/* eslint-disable max-classes-per-file */

/**
 * Primary nav selector
 * @const {string}
 */
const PRIMARY_NAV_SELECTOR = '.primary-nav-wrapper';

/**
 * Primary nav translate button
 * @const {string}
 */
const PRIMARY_NAV_TRANSLATE = '.primary-nav-top__translate';

/**
 * Language assistant menu
 * @const {string}
 */
// const LANGUAGE_ASSISTANT_MENU = '.language-assistant__wrapper--desktop';
const LANGUAGE_ASSISTANT_MENU =
    '.language-assistant__wrapper--desktop > .language-assistant';

/**
 * Language assistant menu svg
 * @const {string}
 */
const LANGUAGE_ASSISTANT_MENU_SVG =
    '.language-assistant__wrapper--desktop > .svg-icon';

/**
 * Desktop nav dark overlay selector
 */

const PRIMARY_NAV_DARK_OVERLAY = '.primary-nav__dark-overlay';

/**
 * Create a new LanguageAssistant
 * @param {HTMLElement} LanguageAssistant - The HTML element of the primary nav
 * @class
 */
class LanguageAssistantImpl {
    constructor(languageAssistantPrimaryNav) {
        this.languageAssistantPrimaryNav = languageAssistantPrimaryNav;

        const translateButton = languageAssistantPrimaryNav.querySelector(
            PRIMARY_NAV_TRANSLATE
        );

        const languageMenu = languageAssistantPrimaryNav.querySelector(
            LANGUAGE_ASSISTANT_MENU
        );

        const languageMenuSvg = languageAssistantPrimaryNav.querySelectorAll(
            LANGUAGE_ASSISTANT_MENU_SVG
        );

        translateButton.addEventListener('mouseover', () => {
            this._setMenuOffset(languageAssistantPrimaryNav, translateButton);
        });

        this._hoverHandlers(translateButton);
        this._hoverHandlers(languageMenu);
        languageMenuSvg.forEach((svg) => this._hoverHandlers(svg));
    }

    _setMenuOffset(languageAssistantPrimaryNav, translateButton) {
        const primaryNav = languageAssistantPrimaryNav;
        const navItem = translateButton;
        const languageMenu = primaryNav.querySelector(LANGUAGE_ASSISTANT_MENU);
        const languageMenuSvg = primaryNav.querySelectorAll(
            LANGUAGE_ASSISTANT_MENU_SVG
        );

        // Measure if the menu is going to be off screen
        const navBarWidth = navItem.offsetParent.offsetWidth; // Width of the navbar element
        const navItemOffset = navItem.offsetLeft; // How far along the navbar the item selected is
        const navItemCenter = navItem.offsetWidth / 2; // center of translate button
        const menuWidth = 636; // THe width of the language menu once shown
        const svgWidth = 34;

        const leftOfLanguageMenu =
            navItemOffset + navItemCenter - menuWidth / 2;

        if (leftOfLanguageMenu + menuWidth > navBarWidth) {
            languageMenu.style.left = `${navBarWidth - menuWidth}px`;
        } else {
            languageMenu.style.left = `${leftOfLanguageMenu}px`;
        }

        const languageMenuLeft = parseInt(
            languageMenu.style.left.substring(
                0,
                languageMenu.style.left.length - 2
            ),
            10
        );

        // places the svg triangle in the center of
        languageMenuSvg.forEach((langMenuSvg) => {
            // eslint-disable-next-line no-param-reassign
            langMenuSvg.style.left = `${
                // eslint-disable-next-line prettier/prettier
            languageMenuLeft + (menuWidth/2) - (svgWidth/2)
            }px`;
        });
    }

    _hoverHandlers(hoverer) {
        hoverer.addEventListener('mouseover', () => {
            // if a nav item with mega menu is hovered over show the dark overlay for screen
            this.languageAssistantPrimaryNav.querySelector(
                PRIMARY_NAV_DARK_OVERLAY
            ).style.display = 'block';
        });

        hoverer.addEventListener('mouseout', () => {
            // if a nav item with mega menu is hovered over show the dark overlay for screen
            this.languageAssistantPrimaryNav.querySelector(
                PRIMARY_NAV_DARK_OVERLAY
            ).style.display = 'none';
        });
    }
}

/**
 * Singleton wrapper for Primary Nav to allow control from other areas of the template.
 * @class
 */
export default class LanguageAssistant {
    static getInstance() {
        const languageAssistantPrimaryNav =
            document.querySelector(PRIMARY_NAV_SELECTOR);

        // primaryNav doesnt exist, return null
        if (!languageAssistantPrimaryNav) {
            return null;
        }

        // Doesnt exist yet, create new menu object
        if (!languageAssistantPrimaryNav._languageAssist) {
            // Store the actual class against the DOM, as if this is destroyed for any reason it will need to be re-instantiated
            languageAssistantPrimaryNav._languageAssist =
                new LanguageAssistantImpl(languageAssistantPrimaryNav);
        }

        // Return existing primaryNav object
        return languageAssistantPrimaryNav._primaryNav;
    }
}

// Export for external access and run intial pass
LanguageAssistant.getInstance();
